<div class="card dialog-box">
  @if (cameraPromptCheck) {
    <div class="card-header">Camera Access</div>
    <div class="d-flex gap-3 ps-2">
      <div class="flex-grow-1">
        <div class="mb-4">
          Tap
          <span class="fw-bold">Allow</span> when prompted for camera access.
        </div>
        <div class="mb-4">
          <label for="cameraPrompt">
            <input
              class="form-check-input"
              type="checkbox"
              id="cameraPrompt"
              (change)="onCloseDialogue(true)"
            />
            Don't show this again</label
          >
        </div>
        <div class="d-flex justify-content-center">
          <button
            class="btn btn-success w-75 btn-md"
            (click)="onCloseDialogue()"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  } @else if (notificationAccessCheck) {
    <div class="card-header">Notification Access</div>
    <div class="d-flex gap-3 ps-2">
      <div>
        <i class="fa-regular fa-bell fa-4x text-primary"></i>
      </div>
      <div class="flex-grow-1">
        <div class="fw-semibold mb-4">Allow Notifications</div>
        @if (notificationStatusInfo) {
          @switch (notificationStatusInfo) {
            <!--
                1: Checking for permission
                2: Provide access if prompted
                -->
            @case (1) {
              <div class="d-flex gap-1 align-items-center">
                <div class="flex-grow-1">Testing notifications.</div>
                <div>
                  <div
                    class="spinner-border text-secondary spinner-border"
                    role="status"
                  ></div>
                </div>
              </div>
            }
            @case (2) {
              <div class="d-flex gap-1 align-items-center fw-semibold">
                <div class="flex-grow-1">
                  Please tap
                  <span class="text-primary fw-bold">Allow</span> when prompted
                  to receive notifications.
                </div>
                <div>
                  <div
                    class="spinner-border text-secondary spinner-border"
                    role="status"
                  ></div>
                </div>
              </div>
            }
            @case (3) {
              <div class="mb-4 fw-semibold">Notifications Allowed</div>
              <div>
                <button
                  class="btn btn-success w-75 btn-md"
                  (click)="notificationAccessCheck = false; checkGpsStatus()"
                >
                  OK
                </button>
              </div>
            }
          }
        }
      </div>
    </div>
  } @else {
    <div class="card-header">
      Location Access {{ showLocationPermissionCurrentStep ? "Guide" : "" }}
      <!-- <span class="float-end" (click)="onDismiss()"
          ><i class="fa-solid fa-xmark"></i
        ></span> -->
    </div>
    @if (showLocationPermissionCurrentStep) {
      @switch (showLocationPermissionCurrentStep) {
        @case (1) {
          <div class="mb-2">
            Open Settings and scroll down till you see
            <span class="fw-semibold text-dark">Privacy and Security</span>. Tap
            on <span class="fw-semibold text-dark">Privacy and Security</span>.
          </div>
          <img
            src="assets/screenshots/ios_location_services/ios_privacy_and_security.avif"
            alt="Guard Tracker"
            class="cursor-pointer mb-2"
          />
        }
        @case (2) {
          <div class="mb-2">
            Make sure
            <span class="fw-semibold text-dark">Location Services</span>
            switched on.
          </div>
          <img
            src="assets/screenshots/ios_location_services/ios_location_services_option.avif"
            alt="Guard Tracker"
            class="cursor-pointer mb-2"
          />
        }
        @case (3) {
          <div class="text-primary mb-2">
            Ensure your browser app has
            <span class="fw-semibold text-dark">Precise Location</span> enabled.
          </div>
          <img
            src="assets/screenshots/ios_location_services/ios_precise_location.avif"
            alt="Guard Tracker"
            class="cursor-pointer mb-2"
          />
        }
      }
      <div class="row row-cols-2">
        <div class="col">
          @if (showLocationPermissionCurrentStep > 1) {
            <button
              type="button"
              class="btn btn-dark w-100 btn-lg"
              (click)="
                showLocationPermissionCurrentStep =
                  showLocationPermissionCurrentStep - 1
              "
            >
              Back
            </button>
          }
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-primary btn-lg w-100"
            (click)="
              showLocationPermissionCurrentStep < 3
                ? (showLocationPermissionCurrentStep =
                    showLocationPermissionCurrentStep + 1)
                : onDismiss(true)
            "
          >
            {{ showLocationPermissionCurrentStep < 3 ? "Next" : "Done" }}
          </button>
        </div>
      </div>
    } @else {
      <div class="d-flex gap-3 ps-2">
        @if (gpsStatusInfo == 3) {
          <div>
            <i class="fa-solid fa-location-dot fa-4x text-success"></i>
          </div>
        } @else if ([4, 5, 6].includes(gpsStatusInfo)) {
          <div>
            <i class="fa-solid fa-location-dot fa-4x text-danger"></i>
          </div>
        } @else {
          <div>
            <i
              class="fa-solid fa-location-dot bell-icon fa-4x text-primary"
            ></i>
          </div>
        }

        <div class="flex-grow-1">
          <div class="fw-semibold mb-4">
            Guard Tracker requires access to location services
          </div>

          @if (gpsStatusInfo) {
            @switch (gpsStatusInfo) {
              <!--
                      1: Checking for permission
                      2: Provide access if prompted
                      3: Fetched GPS successfully
                      4: Permission denied by browser/device
                      5: Some other error
                      6: Browser doesn't support GPS
                      -->
              @case (1) {
                <div class="d-flex gap-1 align-items-center">
                  <div class="flex-grow-1">
                    Checking for access to your location.
                  </div>
                  <div>
                    <div
                      class="spinner-border text-secondary spinner-border"
                      role="status"
                    ></div>
                  </div>
                </div>
              }
              @case (2) {
                <div class="d-flex gap-1 align-items-center fw-semibold">
                  <div class="flex-grow-1">
                    Please tap
                    <span class="text-primary fw-bold">{{
                      isNativeApp ? "Allow While Using App" : "Allow"
                    }}</span>
                    access to your location if prompted.
                  </div>
                  <div>
                    <div
                      class="spinner-border text-secondary spinner-border"
                      role="status"
                    ></div>
                  </div>
                </div>
              }
              @case (3) {
                <div class="text-success mb-4 fw-semibold">
                  Location Services Enabled
                </div>
                <div>
                  <button
                    class="btn btn-success w-75 btn-md"
                    (click)="onDismiss()"
                  >
                    OK
                  </button>
                </div>
              }
              @case (4) {
                @if (isNativeApp) {
                  <div class="text-danger mb-4 fw-semibold">
                    Unable to access your location, please check your app and
                    device settings.
                  </div>
                  <div>
                    @if (
                      devicePlatform == "android" || locationSettingCheck.app
                    ) {
                      <button
                        class="btn btn-primary w-75 btn-md"
                        (click)="openSettings()"
                      >
                        Open
                      </button>
                    } @else {
                      <button
                        class="btn btn-primary w-75 btn-md"
                        (click)="showLocationPermissionCurrentStep = 1"
                      >
                        Show Me How
                      </button>
                    }
                  </div>
                } @else {
                  <div class="text-danger mb-4 fw-semibold">
                    Unable to access your location, please check your browser
                    and device settings.
                  </div>
                  <div>
                    <button
                      class="btn btn-primary w-75 btn-md"
                      (click)="showLocationPermissionCurrentStep = 1"
                    >
                      Show Me How
                    </button>
                  </div>
                }
              }
              @case (5) {
                <div class="text-danger mb-4 fw-semibold">
                  Unable to access your location, Please try again.
                </div>
                <div>
                  <button
                    class="btn btn-primary w-75 btn-md"
                    (click)="checkGpsStatus()"
                  >
                    Retry
                  </button>
                </div>
              }
              @case (6) {
                <div class="text-danger mb-4 fw-semibold">
                  This device may not support location services.
                </div>
                <div>
                  <button
                    class="btn btn-primary w-75 btn-md"
                    (click)="onDismiss()"
                  >
                    Close
                  </button>
                </div>
              }
            }
          }
        </div>
      </div>
    }
  }
</div>
